import * as cn from "./Preloader.scss"

import * as React from "react"

export class Preloader extends React.PureComponent {
    render() {
        return <div className = {cn.preloaderWrapper}>
            <div className = {cn.preloader}>
                <svg width="120px" height="120px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" r="40" stroke="#003274" fill="none" strokeWidth="6" strokeLinecap="round">
                        <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="0" to="502"></animate>
                        <animate attributeName="stroke-dasharray" dur="2s" repeatCount="indefinite" values="150.6 100.4;1 250;150.6 100.4"></animate>
                    </circle>
                </svg>
                Загрузка данных...
            </div>
        </div>
    }
}